import React from "react";
// import socketIOClient from "socket.io-client";
// import * as API from "src/api/request";

const UserContext = React.createContext();

// const initialState = {
//   tn: 0,
//   info: {},
//   userdeps: [],
//   usergroup: "",
//   userGroupList: [],
//   usermenu: [],
//   userzone: [],
//   loggedIn: false,
// };

export const UserStore = (props) => {
  // const [userInfo, setUserInfo] = useState(initialState);
  // const [iframe, setIframe] = useState();
  // const [docmenu, setDocmenu] = useState(false);
  // const [menuID, setMenuID] = useState(localStorage.getItem("eoffice-menuID"));
  // const [menuName, setMenuName] = useState(
  //   localStorage.getItem("eoffice-menuName")
  // );

  // const logOut = () => {
  //   localStorage.removeItem("eoffice_token");
  //   setUserInfo({ ...initialState, loggedIn: false });
  // };

  //useEffect(() => {}, [userInfo.tn]);

  return <>{props.children}</>;
};

export default UserContext;
